import useTranslation from 'next-translate/useTranslation';

import {
  getContestTierCustomNames,
  getTierDisplayLabelByTierNumber,
} from '~/domains/contest/domains/common/utils/playerCardDisplay';
import { Text } from '~/domains/design-system/Text';

import { useContestContext } from '../../../../common/context/ContestContext/ContestContext';

import { PlayerCardEmpty } from './PlayerCardEmpty';

type PlayerCardEmptyPickProps = {
  tierId?: number;
  position?: string;
};

export function PlayerCardUpcomingPlaceholder({ tierId, position }: PlayerCardEmptyPickProps) {
  const { t } = useTranslation('contest');
  const { contest } = useContestContext();
  const customNames = getContestTierCustomNames(contest);
  const tierDisplayLabel =
    typeof tierId === 'number'
      ? getTierDisplayLabelByTierNumber(tierId, customNames)
      : (position ?? '');

  return (
    <PlayerCardEmpty
      label={
        <Text variant="body-large" align="center" maw="90%">
          <Text variant="headline-large">{tierDisplayLabel}</Text>{' '}
          {t('gamecenter.player.common.playerCard.upcomingPlaceholder')}
        </Text>
      }
    />
  );
}
